module.exports = __webpack_public_path__ + "media/images/application/icons/icon-credit-card-a27173c8bb56ed6f9626c139f2e97aa4.svg";